module.exports = __webpack_public_path__ + "img/19.3c2551ef.jpg";